import styled from "styled-components";

interface ContainerProps {
  isSelected: boolean;
}

export const Container = styled.div<ContainerProps>`
  background-color: ${({ theme, isSelected }) => (isSelected ? theme.COLORS.PRIMARY : theme.COLORS.SECONDARY)};
  height: 50px;
  width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 10px;
  cursor: pointer;
  margin-block: 10px;
  margin-inline: 10px;
  transition: all 0.3s ease-in-out;

     @media (max-width: 360px) {
         width: 40%;
    }
     @media (max-width: 768px) {
         width: 40%;
    }
`;
export const SubContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const ContainerImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Logo = styled.img`
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;
export const ContainerText = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
`;
export const Title = styled.h3`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-size: 16px;
  font-weight: 700;
  margin: 0;
  text-align: center;

  @media (max-width: 360px) {
         font-size: 12px;
    }
      @media (max-width: 768px) {
          font-size: 14px;
    }
`;
export const Description = styled.p`
  color: ${({ theme }) => theme.COLORS.DESCRIPTION};
  font-size: 15px;
  font-weight: 500;
  margin: 0;
`;
export const SelectCircle = styled.div`
    width: 25px;
    height: 25px;
    border: 2px solid ${({ theme }) => theme.COLORS.TEXT_DETAILS};
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.SUB_BACKGROUND};
`;
export const Circle = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.COLORS.PRIMARY};
`;